
import TextInputField from '../TextInputField/TextInputField';

type EmailFieldProps = { name: string; label?: string };

const EmailField = (props: EmailFieldProps) => {
    return (
        <TextInputField
            type="email"
            validation={{
                format: '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$',
                formatErrorKey: 'validation.error.email.format',
            }}
            {...props}
        />
    );
};

export default EmailField;
